import T from 'prop-types'

export const resultType = T.oneOf([0, -1]).isRequired

// eslint-disable-next-line consistent-return
export function urlType(props, propName, componentName, location) {
  if (props[propName] && !/http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w-.?%&=]*)?/.test(props[propName])) {
    return new Error(`Invalid ${location} \`${propName}\` => \`${
      JSON.stringify(props[propName])}\` supplied to \`${componentName
    }\`, expected \`url\` pattern.`)
  }
}
